export default "__VITE_ASSET__B7lf2njR__"